import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import {history} from '../../../store';
import UniqueButton from './uniqueButton';

class Tile extends Component {
  originalFourButton() {
    return ['Red', 'Yellow', 'White', 'Grey'].includes(this.props.tile.button_color);
  }

  render() {
    const {
      className, index, tile, tileHeight, unreadMessages
    } = this.props;

    const style = {
      height: tileHeight,
      backgroundImage: `url(${tile.default ? tile.links.default_image || '' : tile.links.image || ''})`,
    };
    return (
      <div className={className}>
        <div className={`tile tile-${index + 1}`} style={style}>
          <div className="background-overlay"/>
          <div className="tile-action">
            {
              tile.button_label && (this.originalFourButton() ? (
                <Button
                  className={`${(tile.button_color || 'red').toLowerCase()}-ghost-btn`}
                  onClick={() => {
                    if (tile.button_link.match(/^https?:.*/i)) {
                      window.open(tile.button_link, '_blank');
                    } else {
                      history.push(tile.button_link);
                    }
                  }}
                >
                  {tile.button_label}
                </Button>
              ) : (
                <UniqueButton
                  buttonColor={tile.button_color}
                  buttonTextColorWhenHover={tile.button_text_color_when_hover}
                  buttonLink={tile.button_link}
                  buttonLabel={tile.button_label}
                />))}
            {
              tile.reference === 'tile_1' && unreadMessages > 0 && (
                <div className="message-count">
                  {unreadMessages}
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default Tile;



// WEBPACK FOOTER //
// ./src/components/common/home/tile.jsx